import angular from 'angular';
import 'ng-file-upload';

const modulesServices = angular.module('applicationModule.modulesServices', ['ngFileUpload']);

modulesServices.factory('Module', ['$http', 'Upload', 'AppsoupAPI', function ($http, Upload, AppsoupAPI) {
    'use strict';

    const API_URL = AppsoupAPI.API_URL + '/module/';
    const checkFiles = function (pdf, logo, more_image, barcode) {
        const files = [];
        const names = [];
        if (angular.isDefined(pdf)) {
            files.push(pdf);
            names.push('pdf');
        }
        if (angular.isDefined(logo)) {
            files.push(logo);
            names.push('logo');
        }
        if (angular.isDefined(more_image)) {
            files.push(more_image);
            names.push('more_image');
        }
        if (angular.isDefined(barcode)) {
            files.push(barcode);
            names.push('barcode_image');
        }

        return {files: files, names: names};
    };

    return {
        get: function (pageId) {
            return $http.get(API_URL + pageId);
        },
        save: function (page, editMode, file, logoImg, moreImg, barcodeImg) {
            let files;
            if (editMode) {
                if (angular.isDefined(file) || angular.isDefined(logoImg) || angular.isDefined(moreImg) || angular.isDefined(barcodeImg)) {
                    files = checkFiles(file, logoImg, moreImg, barcodeImg);
                    const newfields = angular.extend(page, {_method: 'PUT'});

                    return Upload.upload({
                        url: API_URL + page.id,
                        method: 'POST',
                        sendObjectsAsJsonBlob: true,
                        fields: newfields,
                        file: files.files,
                        fileFormDataName: files.names
                    });
                } else {
                    return $http.put(API_URL + page.id, page);
                }
            } else {
                if (angular.isDefined(file) || angular.isDefined(logoImg) || angular.isDefined(moreImg) || angular.isDefined(barcodeImg)) {
                    files = checkFiles(file, logoImg, moreImg, barcodeImg);

                    return Upload.upload({
                        url: API_URL,
                        method: 'POST',
                        sendObjectsAsJsonBlob: true,
                        fields: page,
                        file: files.files,
                        fileFormDataName: files.names
                    });
                } else {
                    return $http.post(API_URL, page);
                }
            }
        },
        remove: function (pageId) {
            return $http.delete(API_URL + pageId);
        },
        getList: function (pageId, clientId) {
            const url = API_URL + (angular.isDefined(clientId) ? 'client-permitted/' + clientId : '');

            return $http.get(url, {params: {page_id: pageId}}).then(function (response) {
                return response.data;
            });
        },
        getToSelect: function (applicationId) {
            const url = API_URL + 'get-list/' + applicationId;

            return $http.get(url);
        },
        getModalData: function (params) {
            const API_URL_MODAL = API_URL + 'create/';

            return $http.get(API_URL_MODAL, {params: params});
        },
        changeOrder: function (data) {
            const url = API_URL + 'change-order/';

            return $http.post(url, data);
        }
    };
}]);

modulesServices.factory('ModuleElement', ['$http', 'Upload', 'AppsoupAPI', function ($http, Upload, AppsoupAPI) {
    'use strict';

    const API_URL = AppsoupAPI.API_URL + '/module-element/';

    const checkFiles = function (file, close, icon_left, icon_right) {
        const files = [];
        const names = [];
        if (angular.isDefined(file)) {
            files.push(file);
            names.push('file');
        }
        if (angular.isDefined(close)) {
            files.push(close);
            names.push('close');
        }
        if (angular.isDefined(icon_left)) {
            files.push(icon_left);
            names.push('icon_left');
        }
        if (angular.isDefined(icon_right)) {
            files.push(icon_right);
            names.push('icon_right');
        }

        return {files: files, names: names};
    };

    return {
        create: function (type, template, app_id, module_id) {
            const url = API_URL + 'create/' + type + '/' + template;

            return $http.get(url, {params: {application_id: app_id, module_id: module_id}});
        },
        status: function (type, template) {
            const url = API_URL + 'status/' + type + '/' + template;

            return $http.get(url);
        },
        remove: function (elementId) {
            return $http.delete(API_URL + elementId);
        },
        getList: function (moduleId, params, clientId) {
            const url = API_URL + (angular.isDefined(clientId) ? 'client-permitted/' + clientId : '');

            return $http.get(url, {params: angular.extend(AppsoupAPI.getTableParams(params), {module_id: moduleId})}).then(function (response) {
                return response.data;
            });
        },
        get: function (pageId) {
            return $http.get(API_URL + pageId);
        },
        save: function (module_element, editMode, file, close, icon_left, icon_right) {
            const files = checkFiles(file, close, icon_left, icon_right);
            if (editMode) {
                if (angular.isDefined(file) || angular.isDefined(close) || angular.isDefined(icon_left) || angular.isDefined(icon_right)) {
                    const newfields = angular.extend(module_element, {_method: 'PUT'});

                    return Upload.upload({
                        url: API_URL + module_element.id,
                        method: 'POST',
                        sendObjectsAsJsonBlob: true,
                        fields: newfields,
                        file: files.files,
                        fileFormDataName: files.names
                    });
                } else {
                    return $http.put(API_URL + module_element.id, module_element);
                }
            } else {
                if (angular.isDefined(file) || angular.isDefined(close) || angular.isDefined(icon_left) || angular.isDefined(icon_right)) {
                    return Upload.upload({
                        url: API_URL,
                        method: 'POST',
                        sendObjectsAsJsonBlob: true,
                        fields: module_element,
                        file: files.files,
                        fileFormDataName: files.names
                    });
                } else {
                    return $http.post(API_URL, module_element);
                }
            }
        },
        changeOrder: function (data) {
            const url = API_URL + 'change-order/';

            return $http.post(url, data);
        }
    };
}]);

export default modulesServices;
